import { ReactNode, useEffect, useState } from "react";

import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Flex,
  Grid,
  Center,
} from "@chakra-ui/react";

import { Text } from "@chakra-ui/react";
import { useCompoundAction, useDepositAction, useWithdrawAction } from "../hooks/useContract";
import { useStakeContractDetail } from "../hooks/useMasterStakeContract";
import {
  useEthers,
  useTokenAllowance,
} from "@usedapp/core";
import { useTokenApproval } from "../hooks/useTokenApproval";
import { BigNumber, ethers } from "ethers";
import { EXPLORER_URL, HERA_TOKEN, LOCKTIME } from "../constants/constrants";

function currencyFormat(num: any) {
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

type Props = {
  children?: ReactNode;
  name?: string;
  imgUrl?: string;
  tokenName?: string;
  buyUrl?: string;
  buyUrlText?: string;
  isActive?: boolean;
  contractAddr: string;
  startPeriod: number;
  finishPeriod: number;
};
/*
export const findBlockMultipler = async (
  startBlock,
  finishBlock,
  blockPerYear
) => {
  const diffBlockNumber = await Number(finishBlock - startBlock);
  return Number(blockPerYear / diffBlockNumber);
};

const allStakedAmount = await nFormatter(
  fromDecimal(_allStakedAmount, stakingTokenDecimals)
);

const mulValue = await findBlockMultipler(
  startBlock,
  finishBlock,
  10512000
);

const pool = Web3.utils.fromWei(_poolTokenAmount.toString(), "ether");
const all = Web3.utils.fromWei(_allStakedAmount.toString(), "ether");
const mul = Number(mulValue);

const APY = Number(((pool * mul) / all) * 100).toFixed(2);
const _allStakedAmount = await ppadChef.methods
          .allStakedAmount()
          .call();
          const poolTokenAmount = await fromDecimal(
            _poolTokenAmount,
            stakingTokenDecimals
          );
          */


export default function StakeRow({
  children,
  name,
  imgUrl,
  tokenName,
  buyUrl,
  buyUrlText,
  isActive,
  contractAddr,
  startPeriod,
  finishPeriod,
}: Props) {
  const [isOpen, setOpen] = useState(isActive);
  const [depositValue, setDepositValue] = useState(0);
  const [withdrawValue, setWithdrawValue] = useState(BigNumber.from(0));
  const [stakeButtonText, setStakeButtonText] = useState("Approve");
  const [needApprove, setNeedApprove] = useState(false);
  const [lockedWithraw, setLockedWithraw] = useState(false);

  const { account } = useEthers();
  const [stakedAmount, claimableAmount, heraPrice, tvl, balance, APY, userDepositTime] =
    useStakeContractDetail(contractAddr, account);

  const data = {
    apr: APY,
    staked: stakedAmount,
    stakedUSDC: Number( ethers.utils.formatEther(stakedAmount)) * heraPrice,
    tvl: tvl,
    tvlUSDC: tvl * heraPrice,
    balance: balance,
    claimable: claimableAmount,
  };

  const allowance = useTokenAllowance(
    HERA_TOKEN,
    account,
    contractAddr
  );

  const {
    state: approveState,
    send: sendApprove,
    events: approveEvent,
  } = useTokenApproval(HERA_TOKEN);

  const {
    state: stakeState,
    send: sendStake,
    events: stakeEvent,
  } = useDepositAction(contractAddr);

  const {
    state: withdrawState,
    send: sendWithdraw,
    events: withdrawEvent,
  } = useWithdrawAction(contractAddr);
  
  const {
    state: compoundState,
    send: sendCompound,
    events: compoundEvent,
  } = useCompoundAction(contractAddr);


  useEffect(() => {
    
    if (
      allowance &&
      depositValue > Number(ethers.utils.formatEther(allowance))
    ) {
      setNeedApprove(true);
      setStakeButtonText("Approve");
    } else {
      setNeedApprove(false);
      setStakeButtonText("Stake");
    }
  }, [depositValue, allowance]);

  useEffect(() =>{
   
    if(userDepositTime && new Date().getTime() <  (userDepositTime + LOCKTIME) * 1000 && new Date().getTime() < finishPeriod * 1000)
      setLockedWithraw(true)
  },[userDepositTime])

  const depositHandler = () => {
    if(needApprove)
    void sendApprove(
      contractAddr,
      ethers.utils.parseEther(depositValue.toString())
    );
    else
    void sendStake(
      ethers.utils.parseEther(depositValue.toString()),
      //account
    );

  };

  const withdrawHandler = () => {
    console.log(lockedWithraw)
    void sendWithdraw(
      withdrawValue//ethers.utils.parseEther(withdrawValue.toString()),
      //BigNumber.from("115632952763532386417014074557845982983703029752705921543048003044110188475994")
    );

  };

  const harvestHandler = () => {
    void sendWithdraw(
      ethers.utils.parseEther("0"),
      //BigNumber.from("115632952763532386417014074557845982983703029752705921543048003044110188475994")
    );

  };

  const compoundHandler = () => {
    void sendCompound(
      //BigNumber.from("115632952763532386417014074557845982983703029752705921543048003044110188475994")
    );

  };


  return (
    data && (
      <div
        className={`gamfi-table-inner active-shape ${
          isOpen ? "expeand-bottom-content" : ""
        }`}
      >
        <div
          className="default-centent expeander-iteam-area d-flex align-items-center justify-content-between"
          onClick={() => setOpen(!isOpen)}
        >
          <Flex columnGap={"5px"} alignItems={"center"} className="list-content list-1 image-row">
            <img src={imgUrl} alt="Previous-Image" /> HERA {name}
          </Flex>
          <div className="list-content list-2">{data.apr}%</div>
          <div className="list-content list-3 color-green">
            <Text>
              {Number( ethers.utils.formatEther(data.staked)).toFixed(2)} {tokenName}
            </Text>
            <Text>~{currencyFormat(data.stakedUSDC)}</Text>
          </div>
          <div className="list-content list-5">
            <Text>
              {data.tvl.toFixed(2)} {tokenName}
            </Text>
            <Text>~{currencyFormat(data.tvlUSDC)}</Text>
          </div>
          <div className="list-content list-6">
            <i className="icon-arrow_down expeand-arrow" />
          </div>
        </div>
        <div className="expeand-centent">
          <div className="expeand-farm mb-20 d-flex align-items-center justify-content-between">
            <div className="farm-form-list">
              <h5 className="mb-18">Stake</h5>
              <div className="farm-form-area mb-27">
                <NumberInput
                  defaultValue={0}
                  min={0}
                  max={data.balance}
                  value={depositValue}
                  onChange={(value: any) => setDepositValue(value)}
                >
                  <NumberInputField />
                  <NumberInputStepper></NumberInputStepper>
                </NumberInput>
                <span
                  className="max hoverable"
                  onClick={() => setDepositValue(data.balance)}
                >
                  MAX
                </span>
                <div className="black-shape">
                  <input
                    type="submit"
                    disabled
                    value={stakeButtonText}
                    onClick={() => depositHandler()}
                  />
                  <span className="hover-shape1" />
                  <span className="hover-shape2" />
                  <span className="hover-shape3" />
                </div>
              </div>
              <span style={{ color: "white" }}>
                Wallet balance:{" "}
                <span
                  onClick={() => setDepositValue(data.balance)}
                  style={{ fontWeight: "bold" }}
                >
                  {data.balance.toFixed(2)} {tokenName}
                </span>
              </span>
            </div>
            <div className="farm-form-list">
              <h5 className="mb-18">Unstake</h5>
              <div className="farm-form-area mb-27">
                <NumberInput
                  defaultValue={0}
                  min={0}
                  max={Number(ethers.utils.formatEther(data.staked))}
                  value={Number( ethers.utils.formatEther(withdrawValue ))}
                  onChange={(value: any) => setWithdrawValue(ethers.utils.parseEther(value ? value : "0" ))}
                >
                  <NumberInputField />
                  <NumberInputStepper></NumberInputStepper>
                </NumberInput>
                <span
                  className="max hoverable"
                  onClick={() => setWithdrawValue(data.staked)}
                >
                  MAX
                </span>
                <div className={lockedWithraw ? "readon" : "black-shape"}  >
                  <input
                    type="submit"
                    value="Withdraw"
                    onClick={() => withdrawHandler()}
                    disabled={lockedWithraw}
                  />
                  <span className="hover-shape1" />
                  <span className="hover-shape2" />
                  <span className="hover-shape3" />
                </div>
              </div>
              <span
                style={{ color: "white" }}
                onClick={() => setWithdrawValue(data.staked)}
              >
                Staked balance:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {Number( ethers.utils.formatEther(data.staked)).toFixed(2)} {tokenName}
                </span>
              </span>
            </div>
            <div className="farm-form-list">
              <h5 className="mb-18">Pending Rewards</h5>
              <div className="farm-form mb-27">
                <span className="unit">
                  {data.claimable.toFixed(4)} {tokenName}
                </span>
                <Grid  rowGap={"5px"}>
                <input
                  className="submit-active"
                  type="submit"
                  value="Harvest"
                  onClick={() => harvestHandler()}
                />
                <input
                  className="submit-active"
                  type="submit"
                  value="Compound"
                  onClick={() => compoundHandler()}
                />
                </Grid>
              </div>
            </div>
          </div>
          <div className="expeand-menu">
            <ul>
              <li>
                {buyUrlText}
                <a href={buyUrl} target={"_blank"}>
                  <i className="icon-link" />
                </a>
              </li>
              <li>
                View Contract
                <a href={EXPLORER_URL + "address/" + contractAddr} target={"_blank"}>
                  <i className="icon-link" />
                </a>
              </li>
              <li >
                <i className="icon-info-circle" /> Stake Period: { new Date(startPeriod * 1000).toLocaleString() } - { new Date(finishPeriod * 1000).toLocaleString() }
              </li>
              {userDepositTime &&  <li>
                <i className="icon-info-circle" /> Unlock: {new Date((userDepositTime + LOCKTIME) * 1000).toLocaleString() }
              </li>}
            </ul>
           <Center marginTop={"20px"}>
           <ul>
            <li style={{marginRight:"0px"}}>
                Your HERA tokens will be locked for 7 days. After that time, you’re free to unstake at any time.
              </li>
              </ul>
           </Center>
              
          </div>
        </div>
        <span className="border-shadow shadow-1" />
        <span className="border-shadow shadow-2" />
        <span className="border-shadow shadow-3" />
        <span className="border-shadow shadow-4" />
      </div>
    )
  );
}
